import { createContext, useContext, useState } from 'react';
export const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
    const [value, setValue] = useState(false);
    const [platform, setPlatform] = useState('Desktop');
    const [previewLang, setPreviewLang] = useState('th');
    const [previewLangTab2, setPreviewLangTab2] = useState('th');
    const [logo, setLogo] = useState();
    const values = {
        value,
        setValue,
        previewLang,
        setPreviewLang,
        previewLangTab2,
        setPreviewLangTab2,
        platform,
        setPlatform,
        setLogo,
        logo
    };
    return (
        <BannerContext.Provider value={values}>
            {children}
        </BannerContext.Provider>
    );
};

export const useBannerContext = () => useContext(BannerContext);
